export enum EnStatusAction {
    sent = 'sent',
    accepted = 'accepted',
    rejected = 'rejected',
    expired = 'expired'
}